module.exports = __webpack_public_path__ + "img/va-range.8ea7b5f4.png";